import { GlobalDialogContext } from 'contexts/GlobalDialogContext';
import { useContext } from 'react';


export const useGlobalDialog = () => useContext(GlobalDialogContext);
